import mobileNav from './mobile-nav';
import activeNav from './active-nav';

export default function siteHeader() {
  mobileNav();
  activeNav();
}
